import type { IconSvgObject } from './types';

const Tick02Icon: IconSvgObject = [
  ["path", { d: "M5 14L8.5 17.5L19 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Tick02Icon;
